import fetch from '../api/fetch'

/**
 * 	Action to fetch the quote list
 *
 * 	@method GET
 */

export function fecthQuoteList(
    page: number = 1,
    perPage: number = 20,
    sortedBy: string = 'clientName',
    sortedType: string = 'asc',
    userId: number
) {

    let params =
        `?page=${page}&perPage=${perPage}&sortedBy=${sortedBy}&sortedType=${sortedType}&userId=${userId ? userId : ''}`

    return {
        type: 'FETCH_QUOTE_LIST',
        payload: fetch(`/quotes/list${params}`, { method: 'GET' }),
    }
}

/**
 * 	Action to fetch the policies list
 *
 * 	@method GET
 */

export function fecthPoliciesList(
    page: number = 1,
    perPage: number = 20,
    sortedBy: string = 'clientName',
    sortedType: string = 'asc',
    userId: number
) {

    let params =
        `?page=${page}&perPage=${perPage}&sortedBy=${sortedBy}&sortedType=${sortedType}&userId=${userId ? userId : ''}`

    return {
        type: 'FETCH_POLICIES_LIST',
        payload: fetch(`/policies/list${params}`, { method: 'GET' }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/clientList.ts